
// Import React dependencies
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initViewportUnits } from './lib/viewport'

type RollupNativeMock = {
  createFilter: () => () => boolean;
  load: () => null;
  transform: () => null;
  resolveId: () => null;
};

// Explicitly declare the global property for TypeScript
declare global {
  interface GlobalThis {
    __ROLLUP_NATIVE_DISABLED__?: boolean;
  }

  interface Window {
    __ROLLUP_NATIVE_DISABLED__: boolean;
    rollupNativeMock?: RollupNativeMock;
    createFilter?: RollupNativeMock['createFilter'];
    load?: RollupNativeMock['load'];
    transform?: RollupNativeMock['transform'];
    resolveId?: RollupNativeMock['resolveId'];
  }
}

// Set global flag as early as possible
window.__ROLLUP_NATIVE_DISABLED__ = true;
if (typeof globalThis !== 'undefined') {
  const globalWithRollupFlag = globalThis as typeof globalThis & {
    __ROLLUP_NATIVE_DISABLED__?: boolean;
  };
  globalWithRollupFlag.__ROLLUP_NATIVE_DISABLED__ = true;
}

const rollupNativeMock: RollupNativeMock = {
  createFilter: () => () => false,
  load: () => null,
  transform: () => null,
  resolveId: () => null,
};

// Create mock functions that might be accessed directly
window.rollupNativeMock = rollupNativeMock;
window.createFilter = rollupNativeMock.createFilter;
window.load = rollupNativeMock.load;
window.transform = rollupNativeMock.transform;
window.resolveId = rollupNativeMock.resolveId;

// Log that our initialization is complete
console.log('[main.tsx] Native module flags initialized');

initViewportUnits();

// Mount the application
createRoot(document.getElementById("root")!).render(<App />);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  const wasServiceWorkerControlled = Boolean(navigator.serviceWorker.controller);
  let hasReloadedForServiceWorkerUpdate = false;

  if (wasServiceWorkerControlled) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasReloadedForServiceWorkerUpdate) {
        return;
      }

      hasReloadedForServiceWorkerUpdate = true;
      window.location.reload();
    });
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('[main.tsx] Service worker registered', registration.scope);
        void registration.update();
      })
      .catch((error) => {
        console.error('[main.tsx] Service worker registration failed', error);
      });
  });
}
